import classNames from 'classnames'
import css from 'styled-jsx/css'
import { PrismicImage, PrismicQuestionsSingle } from '../../prismic-types-d'

type Props = {
  className?: string
  currentQuestion: number
  resultSidebar: PrismicImage
  mobileResultSidebar: PrismicImage
  questions: PrismicQuestionsSingle['data']['body']
}

export const CImageSidebar = ({
  className,
  currentQuestion,
  resultSidebar,
  mobileResultSidebar,
  questions,
}: Props) => {
  return (
    <>
      {questions.map((question, index) => {
        return (
          <div
            className={classNames(
              'c-image-sidebar absolute w-full h-full bg-neutral-dark-gray bg-center bg-cover transition-opacity duration-700 ease-in-out',
              {
                'opacity-100': index === currentQuestion,
                'opacity-0': index !== currentQuestion,
              }
            )}
            key={index}
          >
            <picture>
              <source
                media="(min-width:900px)"
                srcSet={question.primary.background_image.url}
              />
              <source
                media="(min-width:500px)"
                srcSet={question.primary.background_image.mid?.url}
              />
              <img
                src={question.primary.mobile_background_image.url}
                alt="Background image"
                className="absolute top-0 left-0 w-full h-full object-cover z-10"
              />
            </picture>
          </div>
        )
      })}
      <div
        className={classNames(
          'c-image-sidebar absolute w-full h-full bg-neutral-dark-gray bg-center bg-cover transition-opacity duration-700 ease-in-out',
          {
            'opacity-100': currentQuestion === questions.length,
            'opacity-0': currentQuestion !== questions.length,
          }
        )}
      >
        <picture>
          <source media="(min-width:900px)" srcSet={resultSidebar.url} />
          <source media="(min-width:500px)" srcSet={resultSidebar.mid?.url} />
          <img
            src={mobileResultSidebar.url}
            alt="Background image"
            className="absolute top-0 left-0 w-full h-full object-cover z-10"
          />
        </picture>
      </div>
      <style jsx>{styles}</style>
    </>
  )
}

const styles = css`
  @media screen and (max-width: 1112px) {
    .c-image-sidebar::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: #57606c;
      opacity: 0.9;
      z-index: 10;
    }
  }
`
